import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import { debounce } from '../utils/functions';

const $window = $(window);
const $body = $('body');
const $search = $('.search');
const $searchTrigger = $('.navigation__search');
const $searchClose = $('.search__close');
const $searchWrapper = $('.search__wrapper');
const $searchInput = $('.search__input');
const $searchContent = $('.search__content');
const $navMenuTitle = $('.navigation-menu__title');
const $hamburger = $('.hamburger');

$(function () {
    const filter = {
        page: 1,
        search: $searchInput.val(),
        lang: $search.data('lang'),
    };

    $window.on(
        'resize:width',
        debounce(function () {
            hideSearch(filter);
        }, true)
    );
    $searchTrigger.on('click', function (event) {
        event.stopPropagation();
        toggleSearch(filter);
    });
    $searchWrapper.on('click', function (event) {
        event.stopPropagation();
    });
    $body.on('click', function () {
        hideSearch(filter);
    });
    $navMenuTitle.on('click', function () {
        hideSearch(filter, true);
    });
    $hamburger.on('click', function () {
        hideSearch(filter, true);
    });
    $searchClose.on('click', function () {
        hideSearch(filter, true);
    });
    $search.on('keydown', function (e) {
        if ($search.hasClass('active')) {
            if (e.key === 'Tab') {
                e.preventDefault();
            } else if (e.key === 'Escape') {
                hideSearch(filter, true);
            }
        }
    });
    bindSearch(filter);
});

const toggleSearch = (filter) => {
    if ($search.hasClass('active')) {
        hideSearch(filter, true);
    } else {
        showSearch();
    }
};

const showSearch = () => {
    $search.addClass('active');
    $searchTrigger.addClass('active');
    $searchInput.val('');
    $searchInput.trigger('focus');
};

const hideSearch = (filter, force = false) => {
    if ($search.hasClass('active')) {
        if (force === true) {
            $searchInput.val('');
        }
        if (!$searchInput.val()) {
            filter.page = 1;
            filter.search = $searchInput.val();
            reRenderSearch(filter);
            $search.removeClass('active');
            $searchTrigger.removeClass('active');
        }
        $searchTrigger.trigger('focus');
    }
};

const bindPagination = (filter) => {
    $searchContent.off('click', '.pagination__item');
    $searchContent.on('click', '.pagination__item', function () {
        const $thisEl = $(this);
        filter.page = $thisEl.data('page');
        reRenderSearch(filter, true);
    });
};

const bindSearch = (filter) => {
    $searchInput.on(
        'input',
        debounce(function () {
            filter.search = $searchInput.val();
            reRenderSearch(filter);
        })
    );
};

const reRenderSearch = async (filter, scrollTop = false) => {
    if (filter.search === '') {
        filter.page = 1;
        $searchContent.html('');
    } else {
        const data = await getSearchItems(filter);
        $searchContent.html(data.html);
        bindPagination(filter);

        if (scrollTop === true) {
            smoothscroll(0, 0, 500, $search);
        }
    }
};

const getSearchItems = async (filter) => {
    try {
        const response = await fetch(SITE_PARAMS.site_url + '/wp-json/kvop/v1/search/html', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(filter),
        });
        const result = await response.json();
        return result;
    } catch (e) {
        console.log(e);
        return null;
    }
};
